/* Full-screen jackpot win celebration with a count-up. Driven by the `win`
   prop ({ tier, amount }) returned from a spin. Presentation only. */
import { useEffect, useState } from 'react';
import './jackpot.css';

const usd = (n) => '$' + Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function JackpotWinOverlay({ win, onDone }) {
  const [shown, setShown] = useState(0);
  useEffect(() => {
    if (!win) return undefined;
    const amt = Number(win.amount || 0);
    const dur = win.tier === 'MEGA' ? 2600 : 1600;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / dur);
      const e = 1 - Math.pow(1 - t, 3);
      setShown(Math.round(amt * e));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    const done = setTimeout(() => onDone && onDone(), dur + 2000);
    return () => { cancelAnimationFrame(raf); clearTimeout(done); };
  }, [win, onDone]);

  if (!win) return null;
  const tierCls = `jp-${String(win.tier || '').toLowerCase()}`;
  return (
    <div className={`jp-overlay ${tierCls}`} data-testid="jackpot-win-overlay" onClick={onDone} role="button">
      <div className="jp-burst" aria-hidden="true" />
      <div className="jp-win-card">
        <div className="jp-win-tier" data-testid="jackpot-win-tier">{win.tier} JACKPOT!</div>
        <div className="jp-win-amount" data-testid="jackpot-win-amount">{usd(shown)}</div>
        <div className="jp-win-tap">tap to continue</div>
      </div>
    </div>
  );
}

export default JackpotWinOverlay;
